import { Platforms } from 'platforms';
import { CustomImages } from 'ui/assets/images/types';

export const importAssets = async (platform: Platforms): Promise<CustomImages> => {
  try {
    return (
      await import(
        /* webpackChunkName: "[request]" */
        `platforms/${platform}/assets/images`
      )
    ).default;
  } catch (error) {
    console.error('Error loading assets for:', platform);
    return (
      await import(
        /* webpackChunkName: "[request]" */
        `platforms/cashlink/assets/images`
      )
    ).default;
  }
};
